module.exports = __webpack_public_path__ + "static/media/icomoon.f8ef368d.woff";